import { renderGrowl } from "@js/nwcc-growl.js";
import { loadMainNwcc } from "@js/nwcc-template.js";

var forecastStausLongNames = {
    final: "",
    prelim: "Preliminary ",
    raw: "Raw ",
    guidance: "Guidance ",
};

function iMapLoadMain() {
    loadMainNwcc();
    const map = document.getElementById("map");
    map.style.zIndex = 1;
}

window.onload = function () {
    iMapLoadMain();
    function stateChange(newState) {
        setTimeout(function () {
            if (newState == -1) {
                const mapContainer = document.getElementById("map-container");
                mapContainer.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }, 2000);
    }
    setHeaderLongName();
    stateChange(-1);
};

function getForecastStatus() {
    let hash = window.location.hash.substring(1);
    if (hash.includes("forecastStatus")) {
        let argObj = {};
        hash.split("&").forEach((argStr) => {
            let argArr = argStr.split("=");
            argObj[argArr[0]] = argArr[1];
        });
        return argObj.forecastStatus;
    }
    return "final";
}

function setHeaderLongName() {
    let status = getForecastStatus();
    let statusLongName = forecastStausLongNames[status];
    if (status != "final") {
        console.log(`Switching to ${status} forecast mode`);
        let msg =
            "This is not final/approved forecast data, for internal use only! Please be advised this data should only be used for review prior to publishing.";
        renderGrowl(`${statusLongName} Forecast Data!`, msg, "warning", true, 10);
    }
    let longName = `${statusLongName}NWCC Interactive Map`;
    document.querySelector("abbr[slot=application-long-name]").innerHTML = longName;
}
